import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Import from "./pages/Import";
import PrivateRoute from "./PrivateRoute";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
<Route
  path="/import"
  element={
    <PrivateRoute>
      <Import />
    </PrivateRoute>
  }
/> 
     </Routes>
    </BrowserRouter>
  );
}
export default App;